import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowLeft, ArrowRight } from "@phosphor-icons/react";

const images = [
  {
    src: "https://customer-assets.emergentagent.com/job_site-yapalim-1/artifacts/p4zp1jhd_Gemini_Generated_Image_fw9d29fw9d29fw9d.png",
    alt: "DVT Rezidans dış cephe",
    caption: "DVT Rezidans Giriş & Mangal Alanı",
    size: "large",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-yapalim-1/artifacts/0t9w1mq8_Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202026-04-13%20050007.png",
    alt: "Oturma odası",
    caption: "Ferah ve Modern Salon",
    size: "small",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-yapalim-1/artifacts/ddqtmx7b_Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202026-04-13%20045915.png",
    alt: "Yatak odası",
    caption: "Konforlu Yatak Odası",
    size: "small",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-yapalim-1/artifacts/zoheipz1_Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202026-04-13%20050059.png",
    alt: "Suit oda",
    caption: "Lüks Suit Oda & Jakuzi",
    size: "medium",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-yapalim-1/artifacts/a08o7n9b_Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202026-04-13%20045834.png",
    alt: "Mutfak",
    caption: "Modern Kapalı Mutfak",
    size: "medium",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-yapalim-1/artifacts/cg7d612v_Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202026-04-13%20045952.png",
    alt: "Mangal alanı ve manzara",
    caption: "Mangal Alanı & Şehir Manzarası",
    size: "large",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-yapalim-1/artifacts/amk6ltlb_Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202026-04-13%20045902.png",
    alt: "Banyo",
    caption: "Modern Banyo",
    size: "small",
  },
  {
    src: "https://images.unsplash.com/photo-1596252890311-caa6a004a6ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxob3RlbCUyMGJyZWFrZmFzdHxlbnwwfHx8fDE3NzYwNDQ2NTV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Kahvaltı",
    caption: "Zengin Kahvaltı Servisi",
    size: "small",
  },
];

const Gallery = () => {
  const [lightbox, setLightbox] = useState(null);

  const openLightbox = (index) => setLightbox(index);
  const closeLightbox = () => setLightbox(null);
  const prev = () => setLightbox((p) => (p === 0 ? images.length - 1 : p - 1));
  const next = () => setLightbox((p) => (p === images.length - 1 ? 0 : p + 1));

  return (
    <section
      id="galeri"
      data-testid="gallery-section"
      className="section-padding bg-[#EFEAE2]"
    >
      <div className="container-main">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="overline mb-4 inline-block">Galeri</span>
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1A1A1A]">
            Yaşam <span className="text-[#4A5D23]">Alanlarımız</span>
          </h2>
        </motion.div>

        {/* Bento Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 auto-rows-[180px] sm:auto-rows-[220px] lg:auto-rows-[260px]">
          {images.map((img, i) => {
            const spanClass =
              img.size === "large"
                ? "col-span-2 row-span-2"
                : img.size === "medium"
                ? "col-span-2 row-span-1"
                : "col-span-1 row-span-1";

            return (
              <motion.div
                key={i}
                data-testid={`gallery-item-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: Math.min(i * 0.06, 0.35), duration: 0.5 }}
                className={`${spanClass} rounded-2xl overflow-hidden relative cursor-pointer group`}
                onClick={() => openLightbox(i)}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  loading="lazy"
                />
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-all duration-400 flex items-end">
                  <div className="p-4 sm:p-6 w-full">
                    <p className="font-['Playfair_Display'] text-white text-sm sm:text-base lg:text-lg font-semibold translate-y-3 group-hover:translate-y-0 transition-transform duration-400">
                      {img.caption}
                    </p>
                  </div>
                </div>
                {/* Subtle border */}
                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-black/5 pointer-events-none" />
              </motion.div>
            );
          })}
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {lightbox !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/92 backdrop-blur-md flex items-center justify-center p-4 sm:p-8"
            onClick={closeLightbox}
          >
            <button
              data-testid="lightbox-close"
              onClick={closeLightbox}
              className="absolute top-5 right-5 sm:top-8 sm:right-8 w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white/70 hover:text-white hover:bg-white/20 transition-all"
            >
              <X size={22} weight="bold" />
            </button>
            <button
              data-testid="lightbox-prev"
              onClick={(e) => { e.stopPropagation(); prev(); }}
              className="absolute left-3 sm:left-8 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white/70 hover:text-white hover:bg-white/20 transition-all"
            >
              <ArrowLeft size={24} />
            </button>
            <button
              data-testid="lightbox-next"
              onClick={(e) => { e.stopPropagation(); next(); }}
              className="absolute right-3 sm:right-8 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white/70 hover:text-white hover:bg-white/20 transition-all"
            >
              <ArrowRight size={24} />
            </button>
            <motion.div
              key={lightbox}
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.92 }}
              transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
              className="max-w-5xl w-full flex flex-col items-center"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={images[lightbox].src}
                alt={images[lightbox].alt}
                className="max-w-full max-h-[75vh] object-contain rounded-xl shadow-2xl"
              />
              <div className="mt-5 text-center">
                <p className="font-['Playfair_Display'] text-white text-lg font-semibold">
                  {images[lightbox].caption}
                </p>
                <p className="font-['Outfit'] text-white/40 text-sm mt-1.5">
                  {lightbox + 1} / {images.length}
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Gallery;
